import React from 'react';

import { styled } from '@mui/material';
import TableRow from '@mui/material/TableRow';
import { Link } from 'react-router-dom';

export type TableBodyRowProps = {
  row: any;
  classNameButtonRow?: string;
  classNameRow?: string;
  onRowClick?: Function;
  rowLink?: Function;
};

type TableBodyRowProp = TableBodyRowProps & { children: React.ReactNode };

const StyledLink = styled(Link)(({ theme }) => ({
  display: 'contents',
  textDecoration: 'none',
  color: 'inherit',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:focus': {
    outline: 'none',
    outlineOffset: 'none',
  },
}));

const TableBodyRow: React.FC<React.PropsWithChildren<TableBodyRowProp>> = (props) => {
  const { onRowClick, row, classNameButtonRow, classNameRow, children, rowLink } = props;

  if (rowLink) {
    return (
      <TableRow component={StyledLink} to={rowLink(row)} className={classNameButtonRow} hover>
        {children}
      </TableRow>
    );
  }

  const onClick = (e) => {
    e.preventDefault();
    onRowClick && onRowClick({ row });
  };

  if (onRowClick) {
    return (
      <TableRow role="button" onClick={onClick} className={classNameButtonRow}>
        {children}
      </TableRow>
    );
  }

  return <TableRow className={classNameRow}>{children}</TableRow>;
};

export default TableBodyRow;
